import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { LanguageStoreHandlerService } from '../services/language/language-store-handler.service';

export const LanguageGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean | Observable<boolean | UrlTree> => {
  const lang = route.params['language'];

  if (!lang) {
    return true;
  }

  const router = inject(Router);
  const languageService = inject(LanguageStoreHandlerService);

  return languageService.getAll().pipe(
    map((languages) => {
      const validLanguage = languages.find((language) => language.short === lang);
      languageService.switch(validLanguage).subscribe();

      const strippedUrl = state.url.replace(`/${lang}/`, '/');

      return router.parseUrl(strippedUrl);
    }),
  );
};
